import React, { useEffect } from 'react';
import { arrayOf, bool, string } from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useConfiguration } from '../../../context/configurationContext';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { useIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { isMainSearchTypeKeywords } from '../../../util/search';
import { isScrollingDisabled } from '../../../ducks/ui.duck';

import { Page, LayoutSingleColumn, NamedLink, IconSpinner } from '../../../components';

import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import FooterContainer from '../../FooterContainer/FooterContainer';
import { fetchAllStates, getStatesData } from '../../../ducks/strapi.duck';
import { isArrayLength } from '../../../util/genericHelpers';

import css from './CustomPageBuilder.module.css';

const CustomStatesComponent = ({ scrollingDisabled, intl }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllStates());
  }, [dispatch]);

  const { statesData, searchInProgress } = useSelector(getStatesData);

  const schemaTitle = intl.formatMessage({ id: 'CustomStates.headerSubtitle' });
  const schemaDescription = intl.formatMessage({ id: 'CustomStates.headerDescription' });

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        image: [schemaDescription],
      }}
    >
      <LayoutSingleColumn className={css.root} topbar={<></>} footer={<></>}>
        <div className={css.pageRoot}>
          <div className={css.pageHeader}>
            <span>
              {intl.formatMessage({
                id: 'CustomStates.headerTitle',
                defaultMessage: 'States',
              })}
            </span>
            <h1>
              {intl.formatMessage({
                id: 'CustomStates.headerSubtitle',
              })}
            </h1>
            <p>
              {intl.formatMessage({
                id: 'CustomStates.headerDescription',
              })}
            </p>
          </div>
          <div className={css.otherLinksList}>
            {searchInProgress ? (
              <div className={css.iconSpinner}>
                <IconSpinner />
              </div>
            ) : null}
            <ul>
              {isArrayLength(statesData) ? (
                statesData.map(s => (
                  <li key={s?.slug}>
                    <NamedLink name="StateListsPage" params={{ state: s?.slug }}>
                      {s?.title}
                    </NamedLink>
                  </li>
                ))
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

CustomStatesComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  marketplaceName: string.isRequired,
  isKeywordSearch: bool.isRequired,
  intl: intlShape.isRequired,
  routeConfiguration: arrayOf(propTypes.route).isRequired,
};

const EnhancedCustomStates = props => {
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const history = useHistory();
  const intl = useIntl();

  return (
    <CustomStatesComponent
      routeConfiguration={routeConfiguration}
      marketplaceName={config.marketplaceName}
      isKeywordSearch={isMainSearchTypeKeywords(config)}
      history={history}
      intl={intl}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const CustomStates = compose(connect(mapStateToProps))(EnhancedCustomStates);

export default CustomStates;
